import { AfterViewInit, Component, Input } from '@angular/core';
import {  HisBaseGlobalsService, HisUiService } from 'hisng';
import { DynamicAttributeSummarizedItem } from '../../model/dynamic-viewitem/DynamicAttributeSummarizedItem';
import { DynamicFieldValueUtils } from 'app/fs/res/common/service/dynamic-content/dynamic-field-value.utils';

@Component( {
    selector: 'res-dynamic-attribute-items-view',
    templateUrl: './dynamic-attribute-items-view.component.html',
} )
export class DynamicAttributeItemsViewComponent implements AfterViewInit {
    @Input() position: number;
    @Input() dynamicAttributeList: DynamicAttributeSummarizedItem[];
    @Input() showHeader: boolean =false;
    @Input() staticFieldset: string;

    public filteredAttributes: DynamicAttributeSummarizedItem[]= new Array<DynamicAttributeSummarizedItem>();
    constructor( public hisBaseGlobalsService: HisBaseGlobalsService, private hisUiService: HisUiService, public dynamicFieldValueUtils: DynamicFieldValueUtils) { }

    public ngAfterViewInit(): void {
        if ( this.dynamicAttributeList?.length>0 ){
            if ( this.position === undefined ) {
                let sorted: DynamicAttributeSummarizedItem[] = this.sortItems(this.dynamicAttributeList);
                sorted.forEach( (item: DynamicAttributeSummarizedItem)=> {
                    this.filteredAttributes.push(item);
                });
            }
            else{
	                this.dynamicAttributeList.forEach( (item: DynamicAttributeSummarizedItem)=> {
                    if( item.isFieldSet ) {
                        
                        //dynamic fieldset
                        if( item.position !== null) {
                            if( item.position === this.position && item.children.length >0 && !this.staticFieldset ){
                                this.filteredAttributes.push(item);
                            }
                        }
                        
                        //static fieldset
                        else{
                            //ToDO: sort children result.sort((itm1,itm2)=> itm1.sortorder - itm2.sortorder );
	                        item.children.forEach( (childItem: DynamicAttributeSummarizedItem)=> {
	                            if( childItem.position!==null && childItem.position === this.position && 
	                                childItem.parent.label== this.staticFieldset ) {
	                                this.filteredAttributes.push(childItem);
	                            }
	                        });
                        }
                    } 
                    else {
                        if( ( item.position === null && item.parent.position === this.position) ||
                            ( item.position !== null && item.parent.position === null && this.staticFieldset === item.parent.label  ) ) {
                            this.filteredAttributes.push(item);
                        }
                    }
                });
            }
        }
    }
    
    private sortItems(dynamicItems: DynamicAttributeSummarizedItem[] ): DynamicAttributeSummarizedItem[] {
        dynamicItems.sort((itm1,itm2)=> itm1.position - itm2.position );
        return dynamicItems;
    }
}
